// extracted by mini-css-extract-plugin
export default {"reportFilters":"ReportsPage_reportFilters__vbj-S","filters":"ReportsPage_filters__mX4Qq","reportWrapper":"ReportsPage_reportWrapper__n5kqF"};